import React,{Component} from 'react'
import PopUp from './components/popupbox'
import { createUrl, getCookie } from '@/js/src/common/utils'

export function bindPopupTrigger(Children){
	return class PopupTrigger extends Component {
		constructor(props){
            super(props)
            this.state = {
                popData: {
					isOpen: false,
					msg: 'hello',
					jump: '',
					btnTxt: '确定'
				}
			}
			this.changePopData = this.changePopData.bind(this)
        	this.popClose = this.popClose.bind(this)
		}
		popClose(){
			const {popData} = this.state;
			this.setState({
				popData:{
					...popData,
					isOpen: false
				}
			})
		}
		changePopData({msg,jump,btnTxt}){
			console.log(msg,jump,btnTxt)
			this.setState({
				popData:{
					isOpen: true,
					msg,
					jump,
					btnTxt,
				}
			})
		}
		render(){
			const {popData} = this.state;
            return <div>
				<Children changePopData={this.changePopData}/>
				<PopUp {...popData} onClose={this.popClose}/>
			</div>
        }
	}
}
export function saleAjax(opts){
	const {path,type,data,success,error,...others} = opts;
    const _data = type.toLowerCase() === 'post' ? {csrf_token: getCookie('csrf_token'), ...data} : data
    $.ajax({
        url: '//api-content.onethingcloud.com/cn/'+path,
        type: type || 'POST',
        data: _data,
        success: success || function(result){
            console.log(result);
        },
        error: error || function(err) {
            console.log(err);
        },
        crossDomain: true,
        xhrFields: { withCredentials: true },
        cache: false,
        ifModified: true,
        ...others
    })
}
export function checkLogin(success){
    saleAjax({
        path: 'user/checklogin',
        success
    })
}
export function createOrder({data,success}){
    saleAjax({
        path: 'eprocurement/order/create',
        data,
        success
    })
}
export function jumpToLogin() {
    location.href = `${createUrl('html/login')}?jumpurl=${encodeURIComponent(location.href)}`
}
export function getPriceConfig(success){
	saleAjax({
		path: 'eprocurement/order/config',
		type: 'GET',
		success
	})
}




// WEBPACK FOOTER //
// ./js/src/pages/Purchase/util.js